export default [
  {
    path: '/access-control',
    name: 'AccessControl',
    component: resolve => require(['@/views/AccessControl'], resolve)
  },
  // 新增-编辑
  {
    path: '/access/onecode',
    name: 'AccessOnecode',
    component: resolve => require(['@/views/AccessControl/Form/Form'], resolve)
  }
]
